import { render, staticRenderFns } from "./ActivitiesList.vue?vue&type=template&id=55bfbf66&scoped=true&"
import script from "./ActivitiesList.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActivitiesList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bfbf66",
  null
  
)

export default component.exports